import { CustomerUpdateDTO } from '../types';
import { UpdateCustomerActions } from '../store/actions';
import { Ajax } from './Ajax';

export const SupportApiUrls = {
  addressSearchPath: '/adressesok/api/address/search',
  updateCustomerPath: '/adressesok/api/customer/update'
};

export const updateCustomerInIcx = (customerDto: CustomerUpdateDTO, dispatch: any) => {
  dispatch({ type: UpdateCustomerActions.UPDATE_CUSTOMER_INIT });

  Ajax.post(SupportApiUrls.updateCustomerPath, { ...customerDto })
    .then(() => {
      dispatch({ type: UpdateCustomerActions.UPDATE_CUSTOMER_SUCCESS });
    })
    .catch(err => {
      dispatch({ type: UpdateCustomerActions.UPDATE_CUSTOMER_ERROR });
    });
};
